import { gql, useLazyQuery, useQuery } from '@apollo/client';
import {
    DSP_FINANCE_INFO_FIELDS,
    DspFinanceInfoType
} from '../types/DspFinanceInfoType';

/** 总部：按 dspId 查询 DSP 财务档案 */
export const GET_DSP_FINANCE_INFO = gql`
    query GetDspFinanceInfo($dspId: String!) {
        dspFinanceInfo: getDspFinanceInfo(dspId: $dspId) {
            ...DspFinanceInfoFields
        }
    }
    ${DSP_FINANCE_INFO_FIELDS}
`;

/** DSP Owner：查询本账号绑定 DSP 的财务档案，dspId 由服务端从账号绑定关系取 */
export const GET_MY_DSP_FINANCE_INFO = gql`
    query GetMyDspFinanceInfo {
        dspFinanceInfo: getMyDspFinanceInfo {
            ...DspFinanceInfoFields
        }
    }
    ${DSP_FINANCE_INFO_FIELDS}
`;

interface DspFinanceInfoResponse {
    dspFinanceInfo: DspFinanceInfoType;
}

export const useDspFinanceInfoLazy = () =>
    useLazyQuery<DspFinanceInfoResponse, { dspId: string }>(GET_DSP_FINANCE_INFO, {
        fetchPolicy: 'network-only'
    });

export const useMyDspFinanceInfo = () =>
    useQuery<DspFinanceInfoResponse>(GET_MY_DSP_FINANCE_INFO, {
        fetchPolicy: 'network-only'
    });
